import { makeStyles } from "@material-ui/styles";

export default makeStyles({
    container: {
        marginTop: "25px",
        background: "white",
        boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        padding: "10px 27px 20px 27px",
    },

    tituloSeccion: {
        fontSize: "14px",
        lineHeight: "26px",
        color: "#011328",
    },

    filaInputs: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginTop: "10px",
        flexFlow: "row wrap",
    },

    textField: {
        marginRight: "18px",
        "& .MuiOutlinedInput-input": {
            padding: "16px 24px",
        },
        "& .MuiOutlinedInput-root": {
            background: "#fff",
            borderRadius: "6px",
            minWidth: "195px",
        },
        "& .MuiFormLabel-root": {
            fontSize: "14px",
        },
    },

    containerTitulo: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
    },

    ayuda: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: "7px",
        fontWeight: "bold",
        fontSize: "10px",
        lineHeight: "9px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        background: "#727A94",
        color: "white",
    },

    btnAdjuntar: {
        height: "38px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px 18px",
        borderRadius: "6px",
        fontWeight: "500",
        fontSize: "13px",
        lineHeight: "18px",
        color: "#02599E",
        minWidth: "190px",
        cursor: "pointer",
        marginRight: "15px",
        textTransform: "none",
        border: "1px dashed rgba(182, 182, 182, 0.41)",
        "&:focus": {
            outline: "none",
        },
        "&:hover": {
            border: "1px dashed rgba(164, 163, 163, 0.84)",
            background: "#FFFFFF",
        },
    },

    iconoUpload: {
        width: "20px",
        marginRight: "8px",
    },

    iconoExcel: {
        width: "13px",
        marginRight: "8px",
    },

    importantText: {
        textDecoration: "underline",
    },
});
